exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usage-report-box {\n  border: 2px solid #0082D0;\n  display: flex;\n  flex-direction: row;\n  width: 600px;\n  margin: 15px;\n  padding: 30px;\n  justify-content: space-evenly;\n  font-size: 12px;\n}\n\n.usage-report-box span {\n  font-weight: bold;\n}\n\n", ""]);

// exports
